function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesNotebookSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504 504",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 252,
    cy: 252,
    r: 252
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M311.3,67.1L433.2,362l-231.6,95.7L80.8,165.6c4.5-1.7,8.8-4.4,12.8-7c15.1-9.5,31.8-19.7,49.5-17.1 c-0.7-2.5-1.4-4.9-2.1-7.4c7.8,0.4,15.8-1.3,22.8-4.8c0.2-1.2,0.4-2.4,0.6-3.6c23.6-9.4,47.6-18,71.9-25.6c2-0.6,4-1.2,5.9-0.5 c1.6,0.6,2.8,2.1,4.1,3.1c5,3.7,12.3,1.4,16.9-2.7c4.6-4.2,7.6-9.8,12-14.2c6.9-6.8,16.6-10,25.6-13.8 C304.4,70.5,307.9,68.9,311.3,67.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86.603,
    y: 154.208,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 466.8264 216.7645)",
    style: {
      fill: "#FF7058"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.484,
    y: 158.824,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 472.21 224.9274)",
    style: {
      fill: "#FF7058"
    },
    width: 250.599,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 95.802,
    y: 176.514,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 493.0459 256.173)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.306,
    y: 194.598,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 514.3912 288.1041)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.685,
    y: 212.638,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 535.4797 319.9977)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.193,
    y: 230.722,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 556.8326 351.9272)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.697,
    y: 248.805,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 578.1779 383.8583)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.211,
    y: 266.899,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 599.5461 415.8049)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.584,
    y: 284.929,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 620.6193 447.6815)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.088,
    y: 303.012,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 641.9645 479.6126)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.592,
    y: 321.106,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 663.3136 511.563)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.013,
    y: 339.228,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 684.5148 543.5991)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.479,
    y: 357.22,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 705.7513 575.3669)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.983,
    y: 375.313,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 727.1003 607.3172)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.404,
    y: 393.435,
    transform: "matrix(-0.9242 0.3819 -0.3819 -0.9242 748.3015 639.3533)",
    style: {
      fill: "#CED5E0"
    },
    width: 250.599,
    height: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M372.3,114.8v295.3H140.4V117.5c4.5,0.1,9-0.6,13.4-1.4c16.3-2.8,34.2-5.6,48.4,2.9 c0.3-2.4,0.5-4.7,0.8-7.1c6.6,3.1,14,4.5,21.2,4c0.6-0.9,1.2-1.9,1.8-2.8c23.5,0.3,47.1,1.5,70.5,3.5c1.9,0.2,3.9,0.4,5.2,1.6 c1.2,1.1,1.6,2.7,2.4,4.1c2.9,4.9,10,5.6,15.4,3.7s10-5.7,15.3-7.9c8.3-3.4,17.7-2.7,26.8-2.7C365.2,115.3,368.8,115.1,372.3,114.8z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 154.1,
    style: {
      fill: "#FF7058"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 158.7,
    style: {
      fill: "#FF7058"
    },
    width: 231.9,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 176.4,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 194.5,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 212.6,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 230.7,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 248.8,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 266.9,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 285,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 303.1,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 321.2,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 339.3,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 357.4,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 375.4,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 393.5,
    style: {
      fill: "#CED5E0"
    },
    width: 231.9,
    height: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD05B"
    },
    points: "268.5,374.4 288,354.9 249.3,316.2 229.8,335.7 229.7,335.7 218.1,386.2 268.6,374.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#324A5E"
    },
    points: "221.7,370.6 218.1,386.2 233.7,382.6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M405.4,198.9l13,13L268.6,361.6c-3.6,3.6-9.4,3.6-13,0l0,0c-3.6-3.6-3.6-9.4,0-13L405.4,198.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M392.5,185.9l13,13L255.7,348.6c-3.6,3.6-9.4,3.6-13,0l0,0c-3.6-3.6-3.6-9.4,0-13L392.5,185.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M424.8,218.2l-6.4-6.4L268.6,361.6c-3.5,3.5-3.6,9.3-0.1,12.9L424.8,218.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M386.1,179.5l6.4,6.4L242.7,335.7c-3.5,3.5-9.3,3.6-12.9,0.1L386.1,179.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.503,
    y: 183.282,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 567.0426 619.6407)",
    style: {
      fill: "#FFD05B"
    },
    width: 54.699,
    height: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M437.7,205.3L399,166.6l17.2-17.2c1.1-1.1,2.9-1.1,4,0l34.7,34.7c1.1,1.1,1.1,2.9,0,4L437.7,205.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesNotebookSvgrepoCom);
export default __webpack_public_path__ + "static/media/notes-notebook-svgrepo-com.50facdff3f62eeb5729b5c8fbf06b1ee.svg";
export { ForwardRef as ReactComponent };